import { useEffect } from 'react';
import {
  checkCtrlPressed,
  checkAltPressed,
  checkShiftPressed,
} from '@/helpers';

export default props => {
  const { handleKeyboardTyping } = props;

  useEffect(() => {
    window.addEventListener('keyup', onWindowKeyUp);
    window.addEventListener('keydown', onWindowKeyDown);

    return () => {
      window.removeEventListener('keyup', onWindowKeyUp);
      window.removeEventListener('keydown', onWindowKeyDown);
    };
  }, []);

  const onWindowKeyDown = event => {
    const isCtrlPressed = checkCtrlPressed(event);
    const isAltPressed = checkAltPressed(event);
    const isShiftPressed = checkShiftPressed(event);

    if (isCtrlPressed || isAltPressed) {
      return;
    } else if (isShiftPressed) {
      if (isShiftPressed && event.key.length === 1) {
        handleKeyboardTyping(event);
        return;
      }
      return;
    } else if (event.key.length !== 1) {
      return; // navigation, control, function keys
    } else {
      handleKeyboardTyping(event);
    }
  };

  const onWindowKeyUp = () => {};
};
